const WORKOS_STORAGE_KEYS = [
  "workos:user",
  "workos:access-token",
  "workos:refresh-token",
  "workos:expires-at",
  "workos:authentication-method",
  "workos_organization_id",
] as const;

interface ClearAuthKitStateOptions {
  preserveCodeVerifier?: boolean;
}

export function clearAuthKitState({
  preserveCodeVerifier = false,
}: ClearAuthKitStateOptions = {}): void {
  if (!preserveCodeVerifier) {
    window.sessionStorage.removeItem("workos:code-verifier");
  }

  for (const key of WORKOS_STORAGE_KEYS) {
    window.sessionStorage.removeItem(key);
    window.localStorage.removeItem(key);
  }
}

export function hardRedirectToLogin(): void {
  clearAuthKitState();
  window.location.assign(`/login?auth_recovery=${Date.now()}`);
}
